import { useI18n } from "@/coquille-bridge";
import { orignalI18nNamespaces, tNs } from "@/i18n/orignalI18n.js";

export function useOrignalUi() {
  const { lang, setLang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";
  const ui = orignalI18nNamespaces[locale];
  const t = (path, fallback) => tNs(locale, path, fallback);
  return { lang: locale, setLang, ui, t };
}
